import { defineStore } from "pinia";

export const useMainStore = defineStore("main", {
	state: () => {
		return {
			storeCode: "en",
			pwaToken: "",
			pwaCode: "",
			menus: {},
			gBStates: [],
			currency: "£",
			smallScreen: false,
		};
	},
	actions: {
		setStoreCode(storeCode) {
			this.storeCode = storeCode;
		},
		setPwaTokenCode(pwaToken, pwaCode) {
			this.pwaToken = pwaToken;
			this.pwaCode = pwaCode;
		},
		addMenu(menu: any) {
			this.menus[menu.menu_data.identifier] = menu;
		},
		setgBStates(states) {
			this.gBStates = states;
		},
		setCurrency(currency: any) {
			this.currency = currency;
		},
		setSmallScreen(isSmall: boolean) {
			this.smallScreen = isSmall;
		},
	},
});
